import React from "react";
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import queryString from 'query-string';

import {ProjectApp} from "@treeosk/common"

import {backEndUri} from '../../config';
import {applyTheme} from '../../userPrefs';


// A single failed request (server restarting, dropped connection) used to leave the preview blank forever:
// retry a couple of times before giving up.
const fetchJsonWithRetry = async (url, attempts = 3) => {
  for (let attempt = 1; ; attempt++) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (e) {
      if (attempt >= attempts) throw e;
      await new Promise((resolve) => setTimeout(resolve, 700 * attempt));
    }
  }
};

class ProjectPreview extends React.PureComponent {

  state = {};

  componentDidMount() {
    applyTheme(); // en cas d'arrivée depuis l'admin : l'aperçu reste en thème clair
    const { projectId } = this.props.match.params;
    this.fetchPage = this.fetchPage.bind(this);
    fetchJsonWithRetry(`${backEndUri}/project/${projectId}/json?withPages=false`)
      .then(data => this.setState({ project: data }))
      .catch((e) => console.log(`[Preview] project not loaded: ${e}`));
  }

  componentWillUnmount() {
    applyTheme();
  }

  ratioFromParams(params) {
    if (!params.ratio) return undefined;
    if (Number(params.ratio)) return Number(params.ratio);
    const split = params.ratio.split('/');
    if (split.length !== 2) throw Error(`Illegal argument: ratio=${params.ratio}`);
    return parseInt(split[0]) / parseInt(split[1]);
  }

  async fetchPage(pageId) {
    const { projectId } = this.props.match.params;
    return fetchJsonWithRetry(`${backEndUri}/project/${projectId}/page/${pageId}/json`);
  }

  uriTransformer = (uri) => uri

  render() {
    const { project } = this.state;
    if(!project) return null;

    const params = queryString.parse(this.props.location.search);
    const width = parseInt(params.width);
    const ratio = this.ratioFromParams(params);
    const routeBaseName = this.props.location.pathname.replace(/^(.+\/preview)\/?(.*)$/, "$1");

    return <ProjectApp
      routeBaseName={routeBaseName}
      project={project}
      fetchPage={this.fetchPage}
      uriTransformer={this.uriTransformer}
      width={width}
      ratio={ratio}
    />

  }
}

ProjectPreview.propTypes = {
  projectId: PropTypes.string
};

export default withRouter(ProjectPreview);
